import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent {
  @Input() isOpen: boolean = false;
  @Input() title: string = 'Confirm';
  @Input() message: string = '';
  @Input() iconClass: string = 'fas fa-print';
  @Input() isProcessing: boolean = false;
  @Input() showNo: boolean = true;
  @Input() showCancel: boolean = true;
  /** Backdrop z-index; raise when dialog opens inside another modal. */
  @Input() backdropZIndex = 9999;
  /** Primary button label (defaults to 'Yes') */
  @Input() primaryLabel: string = 'Yes';
  /** Secondary 'No' button label (defaults to 'No') */
  @Input() noLabel: string = 'No';
  @Output() yes = new EventEmitter<void>();
  @Output() no = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onYes(): void {
    this.yes.emit();
  }

  onNo(): void {
    this.no.emit();
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal-backdrop')) {
      this.onCancel();
    }
  }
}

